const Initial_value = []

function ProductRed(state = Initial_value, action){
    return state
}

export default ProductRed